<template>
  <NodeEditor
    :node="value"
    @editFinish="$_savingOptionsMixin_onEditFinish"
    @delete="$_savingOptionsMixin_onDelete"
  >
    <div contenteditable="true" class="table-node__title" ref="edit-caption" @input="onInput"></div>
    <table class="table-node" :aria-labelledby="`table-${value.uuid}`">
      <thead class="table-node__header-row">
        <tr>
          <th
            scope="column"
            v-for="columnName in data.columnNames"
            :key="columnName"
            class="table-node__heading-cell"
          >
            {{ columnName }}
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(row, idx) in data.data">
          <tr
            v-if="row && row.filter((el) => Array.isArray(el)).length === 0"
            :key="idx"
            class="table-node__row"
          >
            <th scope="row" class="table-node__heading-cell">{{ data.rowNames[idx] }}</th>
            <Cell
              v-for="(cellData, cellIdx) in row"
              :key="cellIdx"
              :data="cellData"
              class="table-node__cell"
            />
          </tr>

          <tr
            v-else
            v-for="(groupedRow, groupIdx) in row"
            :key="'group-' + groupIdx"
            class="table-node__row"
          >
            <th
              v-if="groupIdx === 0"
              :rowspan="row.length"
              scope="row"
              class="table-node__heading-cell"
            >
              {{ data.rowNames[idx] }}
            </th>
            <Cell
              v-for="(cellData, cellIdx) in groupedRow"
              :key="cellIdx"
              :data="cellData"
              class="table-node__cell"
            />
          </tr>
        </template>
      </tbody>
    </table>
  </NodeEditor>
</template>

<script>
import NodeEditor from '../NodeEditor/NodeEditor.vue';
import Cell from './Cell.vue';

import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';
import setCaretToEnd from '../../lib/setCaretToEnd';
import savingOptionsMixin from '../NodeEditor/Mixins/savingOptionsMixin.js';

export default {
  name: 'EditTable',
  mixins: [savingOptionsMixin],
  components: { Cell, NodeEditor },
  props: {
    value: PigeonDocNodeModel,
  },
  computed: {
    data() {
      return this.value.content.data;
    },
  },
  mounted() {
    this.$refs['edit-caption'].innerHTML = this.value.meta.caption;
    this.$refs['edit-caption'].focus();
    setCaretToEnd(this.$refs['edit-caption']);
  },
  methods: {
    onInput() {
      const updated = {
        ...this.value,
        meta: {
          ...this.value.meta,
          caption: this.$refs['edit-caption'].innerHTML,
        },
      };

      this.$emit('change', updated);
    },
  },
};
</script>
